import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Suspense as _Suspense, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

import { match } from './routes'


export default /*@__PURE__*/_defineComponent({
  __name: 'NuxtPage',
  setup(__props) {

const nuxtApp = useNuxtApp()
const route = useRoute()

const component = computed(() => match(route.path)?.component)
const preloadedPages = new Set<string>([route.path])
nuxtApp.hooks.hook('link:prefetch', url => {
  if (preloadedPages.has(url)) return
  preloadedPages.add(url)
  const path = match(url)
  if (path && path.component && path.component.__asyncResolved !== true) {
    path.component.__asyncLoader?.()
  }
})
const done = nuxtApp.deferHydration()
function onResolve () {
  nextTick(async () => {
    try {
      await nuxtApp.callHook('page:finish', component.value)
    }
    finally {
      done()
    }
  })
}
if (import.meta.client) {
  nuxtApp.hook('page:finish', () =>
    document.documentElement.scrollTo({
      top: 0,
    }),
  )
}

return (_ctx: any,_cache: any) => {
  return (_unref(component))
    ? (_openBlock(), _createBlock(_Suspense, {
        key: 0,
        suspensible: true,
        onPending: _cache[0] || (_cache[0] = () => _unref(nuxtApp).callHook('page:start', _unref(component))),
        onResolve: onResolve
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), {
            key: _unref(route).path.includes('blog') ? _unref(route).path : undefined
          }))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})